import React, { Fragment } from 'react'
import { Box, Uploader, withNotifier, spacer } from 'stylist'
import { Consumer as UploadsConsumer } from 'components/UploadsContext'
import UploadDetails from './UploadDetails'
import styled from 'react-emotion'

const UploaderContainer = styled.div`
  margin: ${spacer(5)} 0;
`

const VideoUploader = ({ notify, hide, children }) => (
  <UploadsConsumer>
    {({ startUpload, abortUpload, removeUpload, uploads }) => (
      <Fragment>
        <h5>Upload a video</h5>
        <UploaderContainer>
          <Uploader
            accept="video/mp4"
            name="file"
            onChange={file =>
              startUpload(file).then(() =>
                notify(
                  'success',
                  'Your video has successfully uploaded, check back soon to view its highlights.',
                  { sticky: true }
                )
              )
            }
          />
        </UploaderContainer>
        {uploads.length ? (
          <Box dividers>
            {uploads.map(upload => (
              <Box.Item pad key={`upload:${upload.url}`}>
                <UploadDetails
                  upload={upload}
                  onCancel={() => abortUpload(upload)}
                  onRemove={() => removeUpload(upload)}
                />
              </Box.Item>
            ))}
          </Box>
        ) : null}
      </Fragment>
    )}
  </UploadsConsumer>
)

export default withNotifier(VideoUploader)



// WEBPACK FOOTER //
// ./src/routes/videos/components/VideoUploaderV2.js